import { IPictureTokenData } from "../interfaces/IPictureTokenData";

export namespace PolicyPictureTokenAdapter {

  export const pictureTokenDataAdapter = (data: IPictureTokenData): string => {
    const token = data.access_token.token;
    
    return token;
  }
}